import React, { useEffect, useState } from "react";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Form } from "react-bootstrap";
import PropTypes from "prop-types";
import './SessionTokenBasedLocation.css'
import { Notification, useToaster } from "rsuite";
import { useTranslation } from "react-i18next";
import { useLoaderData } from "react-router-dom";
import ToasterNotification from "../../../utilities/ToasterNotification";

const LocationSearchInput2 = ({ index=null,handlePlaceChange,value, onChange,placeholder,size,autoSuggestCssClassName,page,from="", setInputField=()=>{}, inputField="Single" }) => {
  const [placePredictions, setPlacePredictions] = useState([]);
  const [sessionToken, setSessionToken] = useState(null);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const toaster = useToaster();
  const { t } = useTranslation();
  let loaderDetails = useLoaderData();
  const fetchPlacePredictions = async (text, triggerKey) => {
    try {
      const { AutocompleteSessionToken, AutocompleteSuggestion } =
        await window.google.maps.importLibrary("places");

      if (!sessionToken) {
        setSessionToken(new AutocompleteSessionToken());
      }

      const request = {
        input: text,
        sessionToken: sessionToken,
        region: loaderDetails?.companydetails?.countryCode ? loaderDetails?.companydetails?.countryCode : "US",
        includedRegionCodes: [loaderDetails?.companydetails?.countryCode ? loaderDetails?.companydetails?.countryCode : "US"]
      };

      const { suggestions } =
        await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);

        if(suggestions?.length > 0){
          setPlacePredictions(suggestions);
          setShowSuggestions(true);
          setInputField("Single")
        }else{
          setPlacePredictions([]);
          setShowSuggestions(false);
          setInputField("Multiple");
          // toaster.push(
          //   <Notification
          //     type={"warning"}
          //     header={t("attention", { defaultValue: "Attention" })}
          //     closable
          //   >
          //     {t("noSuggestionsFoundFillManually", {
          //       defaultValue:
          //         "No Suggestions found. Please enter the location details manually.",
          //     })}
          //   </Notification>,
          //   { placement: "topEnd" }
          // );
          ToasterNotification({
            type: "warning",
            i18keyFormat:"noSuggestionsFoundFillManually",
            message: "No Suggestions found. Please enter the location details manually.",
            options: { position: "top-right", autoClose: 5000 },
          });
        }

      if (suggestions?.length > 0 && triggerKey === "Enter") {
        const place = suggestions[0].placePrediction.toPlace();
        await place.fetchFields({
          fields: [
            "displayName",
            "formattedAddress",
            "addressComponents",
            "location",
          ],
        });
        if ((index != undefined && index != null) || index != "") {
            handlePlaceChange(place, index);
        } else {
            handlePlaceChange(place);
        }
        setPlacePredictions([]);
        setShowSuggestions(false);
        setSessionToken(null)
        setActiveIndex(-1)
      }
    } catch (error) {
      console.error("Error fetching place predictions:", error);
    }
  };

  const handleKeyDown = async (e) => {
      
    if(e?.key==='Enter' && activeIndex === -1){
      setShowSuggestions(false);
    }
    if(e?.key==='Enter' && page=='Search' && activeIndex === -1){
      setShowSuggestions(false);
    }
    if (e.key === "Enter" && value.trim() && activeIndex !== -1) {
      e.preventDefault();
      const selectedText =
        placePredictions[activeIndex]?.placePrediction?.text?.toString();
      fetchPlacePredictions(selectedText, "Enter");
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < placePredictions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : placePredictions.length - 1
      );
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value !== "") {
      fetchPlacePredictions(value);
    }else{
        setPlacePredictions([]);
        setShowSuggestions(false)
    }
  };

  const handlePredictionClick = (item, index) => {
    const selectedText =
      placePredictions[index]?.placePrediction?.text?.toString();
    fetchPlacePredictions(selectedText, "Enter");
  };

  return (
    <div className="position-relative">
      <Form.Control
        type="text"
        placeholder={placeholder || "Enter your location"}
        value={value}
        onChange={(e)=>{
            handleInputChange(e)
            onChange(e)
        }}
        onKeyDown={handleKeyDown}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 300)}
       className={`custom-placeholder`}   
       size={size || 'md'}
      />
      {showSuggestions && placePredictions?.length > 0 && (
        <Card.Body
          // className="position-absolute p-0 m-0 z-3 bg-white shadow mt-1"
          className={`position-absolute p-0 m-0 z-3 bg-white shadow mt-1 cardBodyLocationCss ${autoSuggestCssClassName ? autoSuggestCssClassName :"custom-suggestion-box"} ${from == "education" ? "locationZIndex" : ""}`}
        >
          {placePredictions.map((item, index) => (
            <div
              className={`row border p-0 m-0 pb-2 pt-2 w-100 ${
                activeIndex === index ? "bg-light" : ""
              }`}
              role="button"
              key={item.placePrediction.text.toString()}
              onClick={() => handlePredictionClick(item, index)}
            >
              <div className="col-12">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="text-primary me-1"
                />
                <span>{item.placePrediction.text.toString()}</span>
              </div>
            </div>
          ))}
        </Card.Body>
      )}
    </div>
  );
};

LocationSearchInput2.propTypes = {
  value:PropTypes.any,
  handlePlaceChange:PropTypes.any,
  size:PropTypes.any,
  autoSuggestCssClassName:PropTypes.any,
  page:PropTypes.any,
  placeholder: PropTypes.any
};

export default LocationSearchInput2;